<template>
    <v-layout column style = 'flex: 0 0 auto !important;'>
        <template v-for = '(r,i) in groups'>
            <v-list-group 
                v-intersect = 'onIntersection'
                :data-index = 'i'
                v-if = 'i <= (lastIntersected + 10)'
                :key = 'i' no-action 
                :style = '`border-bottom: 1px solid;border-color: ${!$vuetify.theme.dark? "#EEEEEE;": "#757575;"}`'
            >
                <template v-slot:activator>
                    <v-list-item style = 'display: flex; flex-wrap: wrap;' class = 'mx-0 px-0'>
                        <v-list-item-action class = 'mr-4'>
                            <v-btn 
                                :disabled = 'r.mode_persons == "0"'
                                icon small 
                                :to = '{name: "project", params: {project_id: r.project_id}}' 
                                @click = 'listReportsController = false;'
                            >
                                <v-icon small>mdi-settings-outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title style = 'user-select: none;'>
                                <v-layout row wrap px-4 align-center justify-end style="margin: 0px">
                                    <span :class = '`${$vuetify.breakpoint.smAndUp? "mr-auto":"ml-auto mr-2"}`'>{{r.project_name}}</span>
                                    <div 
                                        v-if = '!$vuetify.breakpoint.smAndUp'
                                        class = 'ma-0 pa-0'
                                        style = 'width: 0; height: 6px;flex-basis: 100%;'
                                    ></div>
                                    <v-chip small disabled class = 'mr-1'>{{r.segment}}</v-chip>
                                    <v-chip small disabled>{{r.vertical}}</v-chip>
                                </v-layout>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <template>
                    <v-list-item 
                        two-line
                        v-for = 'report in r.reports' 
                        :key = 'report.report_id' 
                        :to = '{name: "report", params: report}'
                        class = 'pl-4'
                    >
                        <v-list-item-action class = 'mr-4'>
                            <v-btn 
                                v-if = '!$store.state.userData.meta.favorites.includes(report.report_id)' 
                                @click.prevent = 'addToFavorite(report)' icon small
                            ><v-icon small>mdi-star-outline</v-icon></v-btn>
                            <v-btn v-else @click.prevent = '$store.dispatch("delFavorite", report)' icon small><v-icon small>mdi-star</v-icon></v-btn>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class = 'px-1 font-weight-light'>{{report.name}}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action v-if = '!report.active' class = 'mr-2'>
                            <v-chip small outlined disabled>В архиве</v-chip>
                        </v-list-item-action>
                        <v-list-item-action v-if = 'report.expire_on' class = 'mr-2'>
                            <v-chip label 
                                outlined 
                                small 
                                :color = 'diffTime(report.expire_on, currentMoment) > 24? "light-blue lighten-2": "red darken-2"' 
                                :disabled = 'diffTime(report.expire_on, currentMoment) > 48'
                            >доступ истекает {{formatTime(report.expire_on)}}</v-chip>
                        </v-list-item-action>
                        <v-list-item-action class = 'pa-0 ma-0' v-if ='report.mode_edit != "R"' style = 'min-width: auto !important;'>
                            <v-btn class = 'mr-1' small depressed icon @click.stop.prevent = 'cursorReport = report; visibility.update = true;'>
                                <v-icon small color='light-blue darken-1'>mdi-square-edit-outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-action class = 'pa-0 ma-0' v-if ='report.mode_edit != "R"' style = 'min-width: auto !important;'>
                            <v-btn class = 'mx-auto' small icon @click.stop.prevent = 'cursorReport = report; visibility.delete = true;'>
                                <v-icon small :color = '$store.getters.uiAccentIcon'>delete_outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-list-group>
            <v-skeleton-loader
                type = 'list-item'
                v-else 
                :key = '`loader_${r.project_id}`'
                v-intersect = 'onIntersection'
                :data-index = 'i'
            ></v-skeleton-loader>
        </template>
        <report-delete 
            :initialState.sync = 'visibility.delete' 
            :data = 'cursorReport'
            @requestUpdateReportsList = 'passEvent'
        ></report-delete>
        <report-update 
            :initialState.sync= 'visibility.update' 
            :data = 'cursorReport'
            @requestUpdateReportsList = 'passEvent'
        ></report-update>
    </v-layout>
</template>

<script>
    import UpdateReport from '@/components/entities/reports/UpdateDialog.vue'
    import DeleteReport from '@/components/entities/reports/DeleteDialog.vue'
    import dayjs from 'dayjs'

    export default {
        name: 'ObjectsListGroup',
        props: ['groups'],
        components: {
            'report-update': UpdateReport,
            'report-delete': DeleteReport,
        },
        data: () => ({
            visibility: {
                check: true,
                update: false,
                delete: false
            },
            cursorReport: {},
            lastIntersected: 0,
        }),
        computed: {
            currentMoment() {
                return dayjs()
            }
        },
        watch: {},
        methods: {
            addToFavorite (report) {
                this.$store.dispatch('addFavorite', report)
                this.$dataLayer.$emit('enrich', {
                    event: 'interaction',
                    data: {
                        type: 'change_view',
                        target: 'favorites'
                    },
                    once: false
                })
            },
            onIntersection (e, o) {
                if (e[0].isIntersecting) {
                    this.lastIntersected = parseInt(e[0].target.dataset.index)
                }
            },
            passEvent(e) {
                this.$emit(e, e)
            },
            formatTime(time) {
                return dayjs(time).format('D MMM YYYY')
            },
            diffTime(time1, time2) {
                return dayjs(time1).diff(dayjs(time2), 'hour')
            }
        }
    }
</script>